import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { listLanguage } from '../../../configs/LanguageConfig';
import PopupWarning from '../popup-portal/popup-warning/PopupWarning';
import './change-log-popup.scss';

class ChangeLogsPopup extends PureComponent {
  onOkClick = () => {
    const { hideChangeLogPopup } = this.props;
    hideChangeLogPopup();
  };

  renderContent = () => {
    const { changeLogs, locale } = this.props;

    return (
      <div className="change-logs-content">
        {changeLogs.map((item, index) => {
          const textKey = locale === listLanguage.en ? 'contentEn' : 'content';
          const date = new Date(item.date);
          return (
            <div key={index}>
              <span className="date">{date.toLocaleDateString()}</span> :{' '}
              <span>{item[textKey]}</span>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <PopupWarning
        text={I18n.t('layout.changeLogs')}
        textContent={this.renderContent()}
        onOkClick={this.onOkClick}
      />
    );
  }
}

ChangeLogsPopup.propTypes = {};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(ChangeLogsPopup);
